export const cleanFormData = (formData, formConfig) => {
  for (const key in formConfig) {
    if (formConfig.hasOwnProperty(key) && formConfig[key].isDynamic) {
      for (const formKey in formData) {
        if (formKey !== key) {
          continue;
        }

        if (Array.isArray(formData[formKey])) {
          formData[formKey] = reindexArray(formData[formKey]);
        }
      }
    }
  }
  
  return formData;
};

const reindexArray = (array) => {
  return array.reduce((acc, curr) => {
    if (curr !== null && curr !== undefined) {
      acc.push(curr);
    }

    return acc;
  }, []);
};
